const API_URL = '/api/compras';

/**
 * Registra una compra completa (Cabecera + Detalles)
 * @param {Object} compraData - { proveedor, usuario, total, detalles: [...] }
 */
export const registrarCompras = async (compraData) => {
    try {
        const response = await fetch(API_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(compraData)
        });

        const result = await response.json();

        if (!response.ok) {
            throw new Error(result.error || 'Error al registrar la compra');
        }

        return result;
    } catch (error) {
        console.error("RegistrarCompraService - registrarCompraCompleta:", error);
        return { success: false, error: error.message };
    }
};

/**
 * Envía la solicitud para anular una compra y revertir el stock.
 * @param {number|string} compra_id 
 */
export const anularCompras = async (compra_id) => {
    try {
        const response = await fetch(API_URL, {
            method: 'PATCH', // O 'PUT' según definimos en el API
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ compra_id })
        });

        const result = await response.json();

        if (!response.ok) {
            throw new Error(result.error || 'Error al anular la compra');
        }

        return result;
    } catch (error) {
        console.error("RegistrarCompraService - anularCompra:", error);
        return { success: false, error: error.message };
    }
};